"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuery = exports.getColumns = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _settings = require("../settings.js");
var _Condition = require("../Filter/Condition");
var _renders = _interopRequireDefault(require("../renders"));
var _style = _interopRequireDefault(require("./style.css"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _rowActions = _interopRequireDefault(require("../rowActions"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var conditions = {};
var _loop = function _loop() {
  var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
    type = _Object$entries$_i[0],
    value = _Object$entries$_i[1];
  var list = {};
  value.forEach(function (item) {
    list[item.value] = item;
  });
  conditions[type] = list;
};
for (var _i = 0, _Object$entries = Object.entries(_Condition.allConditions); _i < _Object$entries.length; _i++) {
  _loop();
}
var getQuery = exports.getQuery = function getQuery(settings, prettify) {
  var obj = {};
  var totals = [];
  var variableRegex = /^variables\d+:/;
  var symbols = {
    '[': '***>>>',
    ']': '<<<***'
  };
  function encode(str) {
    for (var _i2 = 0, _Object$entries2 = Object.entries(symbols); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
        key = _Object$entries2$_i[0],
        value = _Object$entries2$_i[1];
      str = str.split(key).join(value);
    }
    if (str.includes('{')) {
      str = str.split('.').join('<<**>>');
    }
    return str;
  }
  function decode(str) {
    for (var _i3 = 0, _Object$entries3 = Object.entries(symbols); _i3 < _Object$entries3.length; _i3++) {
      var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
        key = _Object$entries3$_i[0],
        value = _Object$entries3$_i[1];
      str = str.split(value).join(key);
    }
    str = str.split('<<**>>').join('.');
    return str;
  }
  function removeBrackets(str) {
    // remove all line breaks
    str = str.replace(/(\r\n|\n|\r)/gm, '');

    // keep the part inside quotes unchanged
    var strings = [];
    str = str.replace(/("[\w ]+")/g, function (_, string) {
      strings.push(string);
      return '#string#';
    });

    // keep the part inside parentheses unchanged
    var bodies = [];
    str = str.replace(/\(([^()]*)\)/g, function (_, body) {
      bodies.push(body);
      return '()';
    });
    var regex = /\{([^}]+)\}/g;
    while (regex.test(str)) {
      str = str.replace(regex, '.$1');
    }
    return str.replace(/\(\)/g, function () {
      return '(' + bodies.shift() + ')';
    }).replace(/\s+/g, '').replace(/#string#/g, function () {
      return strings.shift();
    });
  }

  // sort just to preserve query even if the column order has been changed
  var columns = _toConsumableArray(settings.columns).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });

  // Set variables
  (function () {
    var variablesColumns = columns.filter(function (column) {
      return variableRegex.test(column.query);
    });
    var sections = {};
    var _iterator = _createForOfIteratorHelper(variablesColumns),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var column = _step.value;
        var _column$query$split = column.query.split('.variables.'),
          _column$query$split2 = _slicedToArray(_column$query$split, 2),
          left = _column$query$split2[0],
          right = _column$query$split2[1];
        sections[left] = sections[left] || [];
        sections[left].push("\"".concat(right, "\""));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    for (var _i4 = 0, _Object$entries4 = Object.entries(sections); _i4 < _Object$entries4.length; _i4++) {
      var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i4], 2),
        name = _Object$entries4$_i[0],
        _variables = _Object$entries4$_i[1];
      (0, _set2["default"])(obj, removeBrackets("".concat(name, ".variables(name: ***>>>").concat(_variables.join(','), "<<<***)")));
    }
  })();

  // Set other fields
  (function () {
    var otherColumns = columns.filter(function (column) {
      return !column.isAction && !variableRegex.test(column.query);
    });
    var _iterator2 = _createForOfIteratorHelper(otherColumns),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var column = _step2.value;
        var path = encode(column.query || column.name);
        (0, _set2["default"])(obj, removeBrackets(path));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  })();

  // Include additional fields
  (function () {
    var columnsWithRender = columns.filter(function (column) {
      return column.render;
    });
    var _iterator3 = _createForOfIteratorHelper(columnsWithRender),
      _step3;
    try {
      var _loop2 = function _loop2() {
        var column = _step3.value;
        var render = _renders["default"].find(function (item) {
          return item.handle === column.render;
        });
        if (render && render.getAdditionalFields) {
          var additionalFields = render.getAdditionalFields({
            settings: column.renderSettings
          });
          var _iterator4 = _createForOfIteratorHelper(additionalFields),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var path = _step4.value;
              (0, _set2["default"])(obj, removeBrackets(encode(path)));
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop2();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  })();

  // Include total data
  if (settings.showTotal) {
    var columnsWithTotal = columns.filter(function (column) {
      if (!column.includeInTotal) {
        return false;
      }
      if (column.render) {
        var render = _renders["default"].find(function (item) {
          return item.handle === column.render;
        });
        if (render && render.isCustomTotal && render.isCustomTotal({
          settings: column.renderSettings
        })) {
          return false;
        }
      }
      return true;
    });
    var _iterator5 = _createForOfIteratorHelper(columnsWithTotal),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var column = _step5.value;
        totals.push("total".concat(column.id, ": ").concat(settings.totalType, "(field: \"").concat(column.name, "\"").concat(settings.totalType === 'avg' ? ', precision: 2' : '', ")"));
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }

  // Set key field
  (0, _set2["default"])(obj, _settings.levels[settings.level].key);
  function getFields(node) {
    var str = '';
    for (var _i5 = 0, _Object$entries5 = Object.entries(node); _i5 < _Object$entries5.length; _i5++) {
      var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i5], 2),
        key = _Object$entries5$_i[0],
        value = _Object$entries5$_i[1];
      if (!value) {
        str += ' ' + key;
      } else {
        str += ' ' + key + ' { ' + getFields(value) + ' }';
      }
    }
    return str;
  }

  // Get filter
  var constantFilter = function () {
    function traverse(node) {
      if (!node) {
        return '';
      }
      if (node.aggregation === 'all') {
        return "{ AND: [ ".concat(node.conditions.map(traverse).join(' '), " ] }");
      }
      if (node.aggregation === 'any') {
        return "{ OR: [ ".concat(node.conditions.map(traverse).join(' '), " ] }");
      }
      if (node.column) {
        return '{ ' + conditions[node.column.type][node.operator].getCondition({
          field: node.column.id,
          value: node.value
        }) + ' }';
      }
      return '';
    }
    return traverse(settings.filter);
  }();
  var filter = constantFilter ? "{\n            AND: [\n                ".concat(constantFilter, "\n                $filter\n            ]\n        }") : '$filter';
  var variables = [];
  var condition = '';
  if (settings.projectId) {
    if (settings.hasIdentifiable) {
      condition += "\nandHasAll: [{ permission: \"quest.view_identifiable_data\", groupId: ".concat(settings.projectId, " }]");
    }
    condition += "\nandHasAny: [\n    { permission: \"quest.tables\", groupId: ".concat(settings.projectId, " }\n    { permission: \"quest.admin\", groupId: ").concat(settings.projectId, " }\n]");
  }
  if (settings.variables) {
    settings.variables.forEach(function (variable) {
      variables.push("$".concat(variable.name, ": ").concat(variable.type));
    });
  }
  variables = variables.map(function (str) {
    return ", ".concat(str);
  }).join('');
  var query = decode("query($limit: Int, $offset: Int, $orderBy: [OrderBy], $filter: Filter".concat(variables, ") {\n        ").concat(settings.level, "(as: ANY").concat(condition, ") {\n            ").concat(settings.rows, "List(limit: $limit, offset: $offset, orderBy: $orderBy, filter: ").concat(filter, ") {\n                ").concat(getFields(obj), "\n            }\n            ").concat(totals.length > 0 ? "".concat(settings.rows, "Summary(filter: ").concat(filter, ") {").concat(totals.join(' '), "}") : '', "\n            totalCount: ").concat(settings.rows, "Count").concat(constantFilter ? "(filter: ".concat(constantFilter, ")") : '', "\n            filteredCount: ").concat(settings.rows, "Count(filter: ").concat(filter, ")\n            ").concat(settings.extraQuery || '', "\n        }\n    }"));
  return prettify ? prettify(query) : query;
};
var getColumns = exports.getColumns = function getColumns(settings) {
  return settings.columns.map(function (column) {
    var render = column.render && _renders["default"].find(function (item) {
      return item.handle === column.render;
    });
    var columnSettings = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      name: column.name,
      label: column.noWrapHeader ? /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].noWrap
      }, column.label) : column.label,
      sort: !!column.sort,
      filter: !!column.filter
    }, column.filter && column.type === 'boolean' ? {
      filterSettings: {
        type: 'selectbox',
        placeholder: '-- Choose one --',
        options: [{
          label: 'Yes',
          value: true
        }, {
          label: 'No',
          value: false
        }]
      }
    } : {}), column.tooltip ? {
      tooltip: column.tooltip
    } : {}), column.showTopHeader ? {
      topHeader: column.topHeader,
      topHeaderSpan: column.topHeaderSpan,
      topHeaderTooltip: column.topHeaderTooltip
    } : {}), {}, {
      hideInTable: column.hideInTable,
      hideInCsv: column.hideInCsv,
      className: (0, _classnames2["default"])(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _style["default"].bold, column.isBold), _style["default"].center, column.alignment === 'center'), _style["default"].right, column.alignment === 'right'), _style["default"].noWrap, column.noWrapValue))
    }, render ? render.getColumnSettings(column.renderSettings, settings) : {});
    if (column.includeInTotal) {
      if (render && render.isCustomTotal && render.isCustomTotal({
        settings: column.renderSettings
      })) {
        columnSettings.totalPath = true;
      } else {
        columnSettings.totalPath = "".concat(settings.rows, "Summary.total").concat(column.id);
      }
    }
    return columnSettings;
  });
};
var Component = /*#__PURE__*/_react["default"].memo(function (props) {
  var settings = props.settings;
  var query = props.query;
  var columns = getColumns(settings);
  var tableProps = _objectSpread(_objectSpread({}, (0, _pick2["default"])(settings, ['showRowNumbers', 'showTotal', 'totalHeader', 'perPage', 'useTaskMaster'])), props.tableProps);
  var rowActions = settings.rowActions && settings.rowActions.length > 0 ? _rowActions["default"].filter(function (action) {
    return settings.rowActions.includes(action.name);
  }) : [];
  return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], _extends({
    query: query,
    rowKey: _settings.levels[settings.level].key,
    columns: columns,
    rowActions: rowActions
  }, tableProps));
});
Component.propTypes = {
  settings: _propTypes["default"].object,
  tableProps: _propTypes["default"].object
};
Component.defaultProps = {
  tableProps: {}
};
var _default = exports["default"] = Component;